import { FC, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getJobPrefrences,
  updateGenderPreference,
} from "../../../../core/services/adi-service";
import Toggler from "../../shared/forms/Toggler";
import Skeleton from "@mui/material/Skeleton";
import toast from "react-hot-toast";
import Notification from "../../shared/overlays/Notification";
import {
  ExclamationCircleIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
} from "@heroicons/react/24/outline";
import PageHeader from "../../shared/elements/PageHeader";
import { useHistory } from "react-router-dom";

const StudentGenderPreference: FC = () => {
  const [loading, setLoading] = useState(true);
  const [genderName, setGenderName] = useState("");
  const [canChange, setCanChange] = useState(false);
  const history = useHistory();
  const redirectToSettings = () => {
    history.push("/ADI/settings/overview");
  };

  const formik = useFormik({
    initialValues: {
      is_same_gender_job: false,
    },
    validationSchema: Yup.object({
      is_same_gender_job: Yup.boolean(),
    }),
    onSubmit: (values, { setSubmitting, setStatus }) => {
      setStatus("");

      const dataToSubmit = {
        is_same_gender_job: values.is_same_gender_job,
      };

      const toastId = toast.custom(() => (
        <Notification
          colour="gray"
          title="Saving gender preference..."
          description=""
          Icon={ExclamationCircleIcon}
        />
      ));

      updateGenderPreference(dataToSubmit)
        .then(() => {
          toast.custom(
            () => (
              <Notification
                colour="green"
                title="Updated successfully"
                description=""
                Icon={CheckCircleIcon}
              />
            ),
            { id: toastId, duration: 1500 }
          );

          //redirectToSettings();
        })
        .catch((err) => {
          toast.custom(
            () => (
              <Notification
                colour="red"
                title="Failed to save gender preference"
                description=""
                Icon={ExclamationTriangleIcon}
              />
            ),
            { id: toastId }
          );

          setStatus("Error saving gender preference.");
        })
        .finally(() => {
          setSubmitting(false);
        });
    },
    enableReinitialize: true,
  });

  useEffect(() => {
    getJobPrefrences().then((res) => {
      const data = res.data.results;
      formik.setFieldValue("is_same_gender_job", data.is_same_gender_job);
      setGenderName(data.gender_name ?? "Male");
      setCanChange(data.can_change_gender_preference ?? true);
      setLoading(false);
    });
  }, []);

  return (
    <div>
      <div className="mb-5">
        <PageHeader title="Student Gender" backToURL="/ADI/settings/overview" />
      </div>
      <div className="bg-white p-6 rounded shadow">
        <form onSubmit={formik.handleSubmit}>
          {loading ? (
            <Skeleton height={50} width={300} />
          ) : (
            <Toggler
              label={`Show ${genderName} learners only`}
              checked={formik.values.is_same_gender_job}
              onColor="bg-green"
              offColor="bg-danger"
              onChange={() => {
                canChange &&
                  formik.setFieldValue(
                    "is_same_gender_job",
                    !formik.values.is_same_gender_job
                  );
                formik.submitForm();
              }}
              disabled={!canChange || formik.isSubmitting}
            />
          )}

          {!canChange && !loading && (
            <p className="text-sm text-red-500 mt-2">
              You need to specify your gender in the "About You" section to
              change this.
            </p>
          )}

          {formik.status && (
            <p className="text-sm text-red-600 mt-4">{formik.status}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default StudentGenderPreference;
